import { render, staticRenderFns } from "./HealthReportsList.vue?vue&type=template&id=4d18160f"
import script from "./HealthReportsList.vue?vue&type=script&lang=ts"
export * from "./HealthReportsList.vue?vue&type=script&lang=ts"
import style0 from "./HealthReportsList.vue?vue&type=style&index=0&id=4d18160f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports